export default __webpack_public_path__ + "static/media/zionsbank.70c21535.png";